import { useState, useCallback } from 'react';

// AIDEV-NOTE: Preferencia de visualizacao do catalogo (lista x navegacao por grupos).
// Fica em localStorage, e nao no pedido.store: e preferencia do vendedor, deve sobreviver ao
// resetPedido e a troca de pedido. Leitura/escrita protegidas — Safari em aba privada lanca
// ao tocar em localStorage, e travar o catalogo por causa de preferencia seria absurdo.

export type ModoCatalogo = 'lista' | 'grupos';

const CHAVE = 'azoupvendas:catalogo:modo';

function lerModo(): ModoCatalogo {
  try {
    return localStorage.getItem(CHAVE) === 'grupos' ? 'grupos' : 'lista';
  } catch {
    return 'lista';
  }
}

export function useCatalogoModo(): [ModoCatalogo, (modo: ModoCatalogo) => void] {
  const [modo, setModoLocal] = useState<ModoCatalogo>(lerModo);

  const setModo = useCallback((novo: ModoCatalogo) => {
    setModoLocal(novo);
    try {
      localStorage.setItem(CHAVE, novo);
    } catch {
      // preferencia nao persistida — a sessao atual continua funcionando
    }
  }, []);

  return [modo, setModo];
}
